import {
  Typography,
  TypographyVariants,
  TypographyWeights,
  TypographyColors,
} from '@carboledger/ui';
import styles from './EmptyState.module.scss';

/**
 * Props:
 *   icon         decorative glyph above the title
 *   title        the headline
 *   description  supporting copy
 *   action       a call-to-action node
 */
export const EmptyState = ({ icon = null, title, description, action = null }) => {
  return (
    <div className={styles.root}>
      {icon && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      <Typography variant={TypographyVariants.h6} weight={TypographyWeights.semibold}>
        {title}
      </Typography>
      {description && (
        <Typography
          variant={TypographyVariants.body}
          color={TypographyColors.secondary}
          className={styles.description}
        >
          {description}
        </Typography>
      )}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
};
